import React, { ReactNode, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import styles from "./ranking.module.scss";
import pl from "shared/messages/pl";
import { Loader } from "ecom-teams-apps-core";
import CompanyRankingReportSection from "./companyRankingReportSection/CompanyRankingReportSection";
import RankingsService from "motivationCard/service/RankingsService";
import { RankingV3ReportFilter_PublicPeriod } from "shared/service/api/generated";
import { useQuery } from "react-query";
import _ from "lodash";
import { formatDate } from "utils/dateUtils";
import EmptyContent from "view360Card/components/emptyContent/EmptyContent";
import ReportPage from "shared/reports/components/reportPage/ReportPage";
import { IMineTenantElements, IReportEntity, ITenantTableColumn } from "shared/reports/models/models";
import { RankingReportElement, RankingReportEntity } from "motivationCard/service/api/models";
import RankingReportsTableV2 from "./rankingReportsTable/RankingReportsTableV2";
import { IReportEntityType } from "shared/constants/reportConstants";

export interface RankingPageProps {
    period: RankingV3ReportFilter_PublicPeriod;
}

const RankingPage: React.FC<RankingPageProps> = observer((props: RankingPageProps) => {
    const { isFetching, data } = useQuery(["ranking-page", props.period], async () => {
        return await RankingsService.getRankingReport(props.period);
    });

    const renderLoader = () => {
        return (
            <div className={styles.loaderWrapper}>
                <Loader text={pl.reports.loading} />
            </div>
        );
    };

    const renderCompanySectionElements = (mineTenantElements: IMineTenantElements) => {
        return (
            <CompanyRankingReportSection
                key={`CompanyRankingReportSection_${mineTenantElements.tenant.code}`}
                additionalClassName={styles.userTargetReportWrapperItem}
                companyName={mineTenantElements.tenant.displayName}
                reports={mineTenantElements.elements as RankingReportElement[]}
            />
        );
    };

    const renderTableSection = (
        entityType: IReportEntityType,
        entitiesForTable: IReportEntity[],
        tenantTableColumns: ITenantTableColumn[]
    ): ReactNode => {
        return (
            <RankingReportsTableV2
                key={`RankingReportsTable_${entityType.code}`}
                reports={entitiesForTable as RankingReportEntity[]}
                tenantTableColumns={tenantTableColumns}
            />
        );
    };

    if (isFetching) {
        return renderLoader();
    }

    if (data?.list === undefined || data?.list.length === 0) {
        return <EmptyContent message={pl.common.noData} graphic="welcome" />;
    }

    return (
        <ReportPage
            report={data}
            subtitleRow1={pl.motivationCard.headers.salesRank.reportDate(formatDate(data?.effectiveDate))}
            renderCompanySectionElements={renderCompanySectionElements}
            renderTable={renderTableSection}
            renderSummarySection={() => {
                return null;
            }}
        />
    );
});

export default RankingPage;
